
declare global {
    interface Window {
        $: any;
        jQuery: any;
    }
}
import { Component, Vue, Prop, Watch } from "vue-property-decorator";
import 'air-datepicker/dist/css/datepicker.min.css';
import moment from "moment";

const $ = require('jquery');
window.$ = $;
window.jQuery = $;
require('air-datepicker');

export interface BatchFilterData {
    dateFrom: string;
    dateTo: string;
    includeUnprocessed: boolean;
}

@Component({})
export default class BatchFilter extends Vue {
    @Prop({ default: false }) readonly readonly!: boolean;
    @Prop({
        default: () => ({ dateFrom: "", dateTo: "", includeUnprocessed: false })
    })
    readonly initialFilter!: BatchFilterData;

    localFilter: BatchFilterData = {
        dateFrom: "",
        dateTo: "",
        includeUnprocessed: false
    };

    hasSearched: boolean = false;

    mounted() {
        this.localFilter = { ...this.initialFilter };
        (this as any).$root.localizeDatepicker($);
        this.initDatepickers();
    }

    @Watch("initialFilter", { deep: true })
    onInitialFilterChange(val: BatchFilterData) {
        this.localFilter = { ...val };
        this.$nextTick(() => {
            this.restoreDatepickerValues();
        });
    }

    initDatepickers() {
        const _this = this;
        const fields: Array<'dateFrom' | 'dateTo'> = ['dateFrom', 'dateTo'];
        const ids: Record<string, string> = {
            dateFrom: 'batch-start-date',
            dateTo: 'batch-end-date'
        };

        fields.forEach(field => {
            const elem = $(`#${ids[field]}`);
            elem.datepicker({
                language: 'es',
                autoClose: true,
                dateFormat: 'yyyy/mm/dd',
                onSelect: function (formattedDate: string, selectedDate: Date) {
                    if (!formattedDate) {
                        _this.localFilter[field] = '';
                        return;
                    }
                    _this.localFilter[field] = moment(selectedDate).format('YYYY/MM/DD');
                }
            });
        });
    }

    restoreDatepickerValues() {
        const ids: Record<string, string> = {
            dateFrom: 'batch-start-date',
            dateTo: 'batch-end-date'
        };
        (['dateFrom', 'dateTo'] as const).forEach(field => {
            const dp = $(`#${ids[field]}`).datepicker({ dateFormat: 'yyyy/mm/dd' }).data('datepicker');
            const date = moment(this.localFilter[field], 'YYYY/MM/DD');
            if (dp && date.isValid()) {
                dp.selectDate(date.toDate());
            }
        });
    }

    onDateInput(field: 'dateFrom' | 'dateTo', event: Event) {
        this.localFilter[field] = (event.target as HTMLInputElement).value;
    }

    onSearch() {
        this.hasSearched = true;
        if (!this.localFilter.dateFrom || !this.localFilter.dateTo) {
            return;
        }
        this.$emit("search", { ...this.localFilter });
    }

    clearFilter() {
        this.localFilter = { dateFrom: "", dateTo: "", includeUnprocessed: false };
        this.hasSearched = false;
        ['batch-start-date', 'batch-end-date'].forEach(id => {
            const dp = $(`#${id}`).data('datepicker');
            if (dp) dp.clear();
        });
        this.$emit("clear");
    }
}
